export default __webpack_public_path__ + "static/media/breyn.8aeaef16.jpg";